<template>
  <DSelect :items="allCals"
           :isLoading="isLoading"
           :itemsSelected="itemsSelected"
           :allDataLoaded="allDataLoaded"
           :multiple="true"
           :appendToBody="appendToBody"
           :placeholder="this.$t('vue2.dselect.placeholder_calendars')"
           @add="$emit('add', $event)"
           @remove="$emit('remove', $event)"
           @update="$emit('updateItems', $event)">
  </DSelect>
</template>

<script>
import DSelect from './DSelectCals'
// import eventbus from '../../eventbus'
import {mapGetters} from 'vuex'
import docendo from '../../docendo'

export default {
  components: {DSelect},
  props: {
    itemsSelected: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      allDataLoaded: false,
      tags: []
    }
  },
  computed: {
    ...mapGetters([
      'allCalendarsInHash',
      'userCalendars',
      'klassCalendars',
      'allUsersInCalIdHash',
      'roomCalendars',
      'mergeCalendars',
      'otherCalendars',
      'studentCalendars',
      'kindergartenCalendars',
      'clubCalendars'
    ]),
    school () {
      return this.$store.state.activeSchool
    },
    isLoading () {
      return this.$store.state.isLoadingAllUsers
    },
    allCals () {
      return this.usersForSelect.concat(this.kindergartenCalendarsForSelect, this.KlassForSelect, this.roomCalsForDSelect, this.mergeCalendarsForDSelect, this.otherCalendarsForDSelect, this.clubCalendarsForDSelect, this.tagsForSelect, this.studentCalendarsForSelect)
    },
    studentCalendarsForSelect () {
      return this.studentCalendars.map((cal, key) => {
        cal.icon = 'icon-user'
        return cal
      })
    },
    kindergartenCalendarsForSelect () {
      return this.kindergartenCalendars.map((cal, key) => {
        cal.icon = 'icon-users5'
        return cal
      })
    },
    usersForSelect () {
      const users = this.userCalendars.map((cal, key) => {
        if (this.allUsersInCalIdHash[cal.id]) {
          this.$set(cal, 'user_tags', this.allUsersInCalIdHash[cal.id].user_tags)
          this.$set(cal, 'default_thumb_url', this.allUsersInCalIdHash[cal.id].default_thumb_url)
        }
        return cal
      })
      return users
    },
    KlassForSelect () {
      const klasses = this.klassCalendars.map((cal, key) => {
        cal.icon = 'icon-calendar4'
        return cal
      })
      return klasses
    },
    roomCalsForDSelect () {
      const rooms = this.roomCalendars.map((cal, key) => {
        cal.icon = 'icon-location'
        return cal
      })
      return rooms
    },
    mergeCalendarsForDSelect () {
      const mergeCals = this.mergeCalendars.map((cal, key) => {
        cal.icon = 'icon-calendar-week'
        return cal
      })
      return mergeCals
    },
    otherCalendarsForDSelect () {
      const otherCalendars = this.otherCalendars.map((cal, key) => {
        cal.icon = 'icon-clipboard2'
        return cal
      })
      return otherCalendars
    },
    tagsForSelect () {
      // tag_id is a hardcoded value greater than largest userid
      let tags = []
      let i = 0
      this.tags.forEach(tag => {
        i++
        let oneTag = {
          tag: true,
          id: 999999999999 + i,
          name: tag,
          icon: 'icon-price-tag2'
        }
        tags.push(oneTag)
      })
      return tags
    },
    clubCalendarsForDSelect () {
      const clubCalendars = this.clubCalendars.map((cal, key) => {
        cal.icon = 'icon-users5'
        return cal
      })
      return clubCalendars
    }
  },
  methods: {
    getTags () {
      docendo.schoolTags(this.school.id, data => {
        this.tags = data
        this.allDataLoaded = true
      })
    }
  },
  beforeMount () {
    this.$store.dispatch('getUsersFromSchoolId', this.school.id)
    this.getTags()
  }
}
</script>



// WEBPACK FOOTER //
// DSelectCalsAll.vue?66bde8cb